module.exports = __webpack_public_path__ + "img/2025-11-17c_16.94ade7e6.jpg";